import Layout from "../../components/Layout";
import NextHead from "../../components/Seo/NextHead";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import { faqBreadcrumb, defBreadcrumb } from "../../data/DataBreadcrumb";
import Topics from "../../components/Faq/Topics";
import LayoutCenter from "../../components/UserInterface/LayoutCenter";
import HeadingComponent from "../../components/UserInterface/HeadingComponent";
import { pertanyaanUmumMeta } from "../../data/DataMetatags";
import { HEADER_NONE } from "../../utils/constanta";
import Questions from "../../components/Faq/Questions";
import DefaultContactInformation from "src/components/UserInterface/DefaultContactInformation";
import axios from "axios";
import { env } from "src/utils/env";

const PertanyaanUmum = ({
  asPath,
  breadcrumb,
  questions,
  title,
  description,
  faq,
  query,
}) => {
  const header = query?.header ? JSON.parse(query?.header) : true;

  return (
    <Layout headerTypeProps={!header && HEADER_NONE}>
      <NextHead
        title={title}
        url={asPath}
        description={description}
        breadcrumb={breadcrumb}
      ></NextHead>
      <BreadcrumbComponent
        items={faqBreadcrumb}
        visibility={!header}
      ></BreadcrumbComponent>
      <HeadingComponent
        headingText="Pertanyaan Umum"
        margin="0px 0px 20px 0px"
      ></HeadingComponent>
      <LayoutCenter alignItem>
        <div className="topics-qna-container">
          <div className="topics-wrapper">
            <Topics dataQuestions={questions} topicId={questions[0].codename} />
          </div>
          <div className="qna-wrapper">
            <div className="qna-container">
              <Questions data={faq} topicId={questions[0].codename} />
            </div>
          </div>
        </div>
      </LayoutCenter>
      <DefaultContactInformation />
      <style jsx>{`
        .topics-qna-container {
          display: grid;
          grid-template-columns: 1fr 2fr;
          grid-column-gap: 25px;
        }

        @media only screen and (max-width: 600px) {
          .topics-qna-container {
            grid-template-columns: 1fr;
          }
          .topics-wrapper {
            order: 2;
          }
          .qna-wrapper {
            order: 1;
          }
          .qna-container {
            display: none;
          }
        }
      `}</style>
    </Layout>
  );
};

PertanyaanUmum.getInitialProps = async ({ res, asPath, query }) => {
  const { title, description } = pertanyaanUmumMeta;

  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + asPath,
        name: title,
      },
    },
  ];

  const { status: questionsStatus, data: questionsData } = await axios.get(
    `${env.baseUrl}/api/v1/kentico/questions`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${env.auth}`,
      },
    }
  );

  if (questionsStatus === 200) {
    const { status: topicFaqStatus, data: topicFaqData } = await axios.get(
      `${env.baseUrl}/api/v1/kentico/topic-faq`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${env.auth}`,
        },
        params: {
          topicId: questionsData[0].codename,
        },
      }
    );

    if (topicFaqStatus === 200) {
      return {
        asPath,
        breadcrumb,
        questions: questionsData,
        title,
        description,
        faq: topicFaqData.data,
        query,
      };
    } else {
      if (res) {
        res.writeHead(301, {
          Location: `/halaman-tidak-ditemukan?q=faq`,
        });
        res.end();
      }
      return;
    }
  } else {
    if (res) {
      res.writeHead(301, {
        Location: `/halaman-tidak-ditemukan?q=pertanyaan-umum`,
      });
      res.end();
    }
    return;
  }
};

export default PertanyaanUmum;
